export default [
  {
    path: '/credit',
    component: (resolve) => require(['@/views/credit_management/index'], resolve),
    hidden: true,
    meta: {
      title: '积分管理',
      code: 'credit_management',
    },
    children: [
      {
        path: 'user_credit_record',
        component: (resolve) => require(['@/views/credit_management/user_credit_record/index'], resolve),
        meta: {
          title: '用户积分记录',
          code: 'user_credit_record',
        },
      },
      {
        path: 'user_credit',
        component: (resolve) => require(['@/views/credit_management/user_credit/index'], resolve),
        meta: {
          title: '用户积分',
          code: 'user_credit',
        },
      },
      {
        path: 'user_credit_type',
        component: (resolve) => require(['@/views/credit_management/user_credit_type/index'], resolve),
        meta: {
          title: '用户积分类型',
          code: 'user_credit_type',
        },
      },
      {
        path: 'credit_goods_manage',
        component: (resolve) => require(['@/views/credit_management/credit_goods_manage/index'], resolve),
        meta: {
          title: '积分商品管理',
          code: 'credit_goods_manage',
        },
      },
      {
        path: 'credit_rule',
        component: (resolve) => require(['@/views/credit_management/credit_rule/index.vue'], resolve),
        meta: {
          title: '积分规则',
          code: 'credit_rule',
        },
      },
      {
        path: 'exchange_examine',
        component: (resolve) => require(['@/views/credit_management/exchange_examine/index.vue'], resolve),
        meta: {
          title: '兑换审核',
          code: 'exchange_examine',
        },
      },
      {
        path: 'exchange_examine',
        component: (resolve) => require(['@/views/credit_management/exchange_examine/index.vue'], resolve),
        meta: {
          title: '兑换审核',
          code: 'exchange_examine',
        },
      },
      {
        path: 'credit_feedback',
        component: (resolve) => require(['@/views/credit_management/credit_feedback/index.vue'], resolve),
        meta: {
          title: '积分反馈',
          code: 'credit_feedback',
        },
      },
    ]
  }
]


// WEBPACK FOOTER //
// ./src/router/module/credit_management.js